export const colors = {
	// Base colors
	white: '#FFFFFF',
	black: '#000000',
	transparent: 'transparent',

	// Gray scale
	gray50: '#F9FAFB',
	gray100: '#F3F4F6',
	gray200: '#E5E7EB',
	gray300: '#D1D5DB',
	gray400: '#9CA3AF',
	gray500: '#a6a6a6',
	gray600: '#4D4D4D',
	gray700: '#374151',
	gray800: '#1F2937',
	gray900: '#111827',
	grayTranslucent: '#55555515',

	// Blue scale
	blue50: '#EFF6FF',
	blue100: '#DBEAFE',
	blue200: '#BFDBFE',
	blue300: '#93C5FD',
	blue400: '#60A5FA',
	blue500: '#3B82F6',
	blue600: '#2563EB',
	blue700: '#1D4ED8',
	blue800: '#1E40AF',
	blue900: '#1E3A8A',

	// Red scale
	red500: '#dc3545',

	// Green scale
	green500: '#57b042',
	green600: '#16A34A',
} as const

export type Color = keyof typeof colors

export const radii = {
	none: 0,
	small: 4,
	medium: 8,
	large: 12,
	full: 9999,
} as const

export type Radius = keyof typeof radii

export const maxWidths = {
	none: '100%',
	small: 400,
	medium: 740,
	large: 1064,
	content: 1280,
} as const

export type MaxWidth = keyof typeof maxWidths
